var editFuelCard = (function () {

    const init = function () {
        $('#card-type-group input[type=radio]').change(function() {
            $('#card-type-group span').hide();
        });
    };

    return {
        init: init
    };

})();
